/*
Lalitha 12/19/2022  3075154998 Added Search Data Manager Form
Sohel  12/19/2022 3075154998 removed fields.
Lalitha 12/20/2022  3075154998 Added Created Date in Data Manager Form
Lalitha 12/23/2022  3075154998 Added Status Field in Data Manager Form
Sohel 12/23/2022 3075154998 Integrated Data Manager Search API
Suresh Peddavoora 01/03/2023 3075154998 Fixed Responsive issues for Textfields and Buttons
dilip 01/09/2023 3075154998 Added Search data session storage functionality
Sohel 01/09/2023 3075154998 Added conditionally Search data session storage functionality
kavyareddy 01/10/2023 3075154998 Fixed code issue
dilip 01/10/2023 3075154998 Removed Type field.
Prakash 01/16/2023 3075154998 Fixed Responsiveness.
Suresh Peddavoora 01/17/2023 3075154998 Fixed Responsive issues for Textfields and Buttons
Suresh Peddavoora 01/19/2023 3075154998 Added Classnames for Textfields
Sohel 01/20/2023 3075154998 changed Dropdown Values
Dilip 02/09/2023 3075154998 added created for, created by dropdown
sai krishna 02/13/2023 3075154998 added search client code field
suresh peddavoora 02/22/2023 3075154998 New UI changes implemented
suresh peddavoora 02/27/2023 3075154998 New UI changes
Raghu 02/27/2023 3075154998 fixed ui alignments
Rohini 02/28/2023 3075154998 changed the columns grid for screen enhancements.
suresh peddavoora 03/01/2023 3075154998 New UI changes
Rohini 03/09/2023 3075154998 fixed the alignment issue in text fields.
Raghu 03/14/2023 3075154998 fixed the alignment issues in responsive
Prakash 03/16/2023 3075154998 fixed ui bugs in responsive.
T Santosh Kumar 17/03/2023 3075154998 New UI Alignment Changes
Prakash 03/17/2023 3075154998 fixed alignments in responsive.
Prakash 03/20/2023 3075154998 fixed alignments issues.
Akhila 04/19/2023 3075154998 client code dropDown Data fix
Sohel 05/22/2023 3075154998 Added Imports and Exports in Schedular
Prakash 22/05/2023 3075154998 fixed popup issue.
Sohel 05/26/2023 3225736869 Added Created Date Validation
Akhila 06/08/2023 3225736869 rearrange the column and form fields
Akhila 06/12/2023 3225736869 added role access
Prakash 22/06/2023 3225736869 fixed alignments issues

*/
import React, {useContext, useEffect, useState} from 'react';
import {Form, Formik} from 'formik';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import SearchDMTable from './SearchDMTable';
import {
  getAllReportCreatedForData,
  fetchCreatedForDropDownData,
  fetchCreatedByDropDownData,
} from '../../../redux/reducers/ReportMaster';
import {getClientCodeDropDownData} from '../../../redux/reducers/TriggerGroup';
import * as Yup from 'yup';

function SearchDataManager({
  setValue,
  exportManager,
  isSchedular = false,
  setDMCode = () => {},
  setIsCodeSearch = () => {},
  setEditExisting,
  DataManagerAccess,
  setDmTableData = () => {},
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const dispatch = useDispatch();
  const initialValues = {
    code: '',
    description: '',
    infoReceiverId: '',
  };
  const validationSchema = Yup.object().shape({});
  const handleSubmit = (values) => {
    if (!isSchedular) {
      if (exportManager) {
        sessionStorage.setItem('EMSearchData', JSON.stringify(values));
      } else {
        sessionStorage.setItem('IMSearchData', JSON.stringify(values));
      }
    }

    setSearchData(values);
    setSubmit(true);
  };
  useEffect(() => {
    dispatch(getClientCodeDropDownData());
    dispatch(getAllReportCreatedForData());
    setEditExisting && setEditExisting(false);
  }, []);

  useEffect(() => {
    if (!exportManager) {
      dispatch(fetchCreatedForDropDownData('importmanager'));
    } else {
      dispatch(fetchCreatedForDropDownData('exportmanager'));
    }
  }, [dispatch]);

  useEffect(() => {
    if (!exportManager) {
      dispatch(fetchCreatedByDropDownData('importmanager'));
    } else {
      dispatch(fetchCreatedByDropDownData('exportmanager'));
    }
  }, [dispatch]);

  const onClear = () => {
    const data = {
      dataManagerCode: '',
      dataManagerDescripton: '',
      createdFor: '',
      createdBy: '',
      dataManagerType: '',
      createdDate: null,
      isDraft: isSchedular ? {key: 'N', value: 'Completed'} : '',
      clientCode: '',
    };
    setSearchData(data);
    if (exportManager) {
      sessionStorage.removeItem('EMSearchData');
    } else {
      sessionStorage.removeItem('IMSearchData');
    }
  };

  const IMDataSessionStorage = exportManager ?
    JSON.parse(sessionStorage.getItem('EMSearchData')) :
    JSON.parse(sessionStorage.getItem('IMSearchData'));

  return (
    <div>
      <div className={exportManager ? 'col-12 ' : isSchedular ? 'col-12' : ''}>
        <Formik
          onSubmit={handleSubmit}
          initialValues={
            IMDataSessionStorage && !isSchedular ? IMDataSessionStorage : initialValues
          }
          enableReinitialize
          validationSchema={validationSchema}
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleReset,
              handleBlur,
              touched,
              errors,
            } = props;

            return (
              <div>
                <Form autoComplete="off">
                  <div className="form-row  standard-field-textfields new-standard-textfields">
                    <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                      <TextField
                        className={` ${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Export Code`}
                        label={`Export Code`}
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="code"
                        value={values?.code}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.code}
                        error={Boolean(touched.code && errors.code)}
                      />
                      <FormHelperText>{touched.code && errors?.code && errors.code}</FormHelperText>
                    </div>
                    <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                      <TextField
                        className={` ${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Export Description`}
                        label={`Export Description`}
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.description}
                        error={Boolean(touched.description && errors.description)}
                      />
                      <FormHelperText>
                        {touched.description && errors?.description && errors.description}
                      </FormHelperText>
                    </div>
                    <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={`${classes.labelName}`}
                        placeholder={`Enter Info Receiver Id`}
                        label="Info Receiver Id"
                        // InputLabelProps={{
                        //     shrink: true,
                        // }}
                        // InputProps={{
                        //   inputComponent: NumberFormatter,
                        // }}
                        name="infoReceiverId"
                        value={values?.infoReceiverId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched?.infoReceiverId}
                        error={Boolean(touched?.infoReceiverId && errors?.infoReceiverId)}
                      />
                      <FormHelperText>
                        {touched.infoReceiverId && errors?.infoReceiverId && errors.infoReceiverId}
                      </FormHelperText>
                    </div>

                    <div
                      className={
                        exportManager ?
                          'col-md-4 col-lg-3 col-xl-3 form-group' :
                          'col-md-12 col-lg-12 col-xl-3 form-group new-standard-textfields'
                      }
                    >
                      <div
                        className={
                          exportManager ?
                            ' d-flex justify-content-center new-standard-textfields justify-content-xl-start' :
                            'd-flex justify-content-xl-start  justify-content-md-center new-standard-textfields'
                        }
                      >
                        <Button
                          variant="outlined"
                          className={`mr-1 reset-btn`}
                          onClick={() => {
                            handleReset();
                            setSubmit(true);
                            onClear();
                          }}
                        >
                          Reset
                        </Button>
                        <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                          Search
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <SearchDMTable
          setValue={setValue}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          exportManager={exportManager}
          isSchedular={isSchedular}
          setDMCode={setDMCode}
          setIsCodeSearch={setIsCodeSearch}
          setEditExisting={setEditExisting}
          DataManagerAccess={DataManagerAccess}
          setDmTableData={setDmTableData}
        />
      </div>
    </div>
  );
}

export default SearchDataManager;
